<template>
  <button class="solicitar-carteira" @click="redirectToNewRegistration">
    <div class="box">
      <el-row>
        <el-col :span="10">
          <img src="@/assets/nova-carteira.svg" alt="Nova Carteira" />
        </el-col>
        <el-col :span="12" class="texto-alinhado">
          <span>Solicitar uma nova Carteira de Pesca</span>
        </el-col>
      </el-row>
    </div>
  </button>
</template>

<script>
export default {
  methods: {
    redirectToNewRegistration() {
      this.$router.push("/novo-cadastro");
    }
  }
};
</script>

<style scoped>
.solicitar-carteira {
  position: relative;
  border: 2px solid #28a745;
  border-radius: 8px;
  display: flex;
  background-color: #28a745;
  color: white;
  padding: 1.7rem 1rem;
  gap: 1rem;
  margin: 0 0 1rem 0;
  cursor: pointer;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  flex: 1;
}

.solicitar-carteira:hover {
  background-color: #218838;
}

.solicitar-carteira .box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.el-row {
  vertical-align: middle;
}

.texto-alinhado {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>
